export default __webpack_public_path__ + "static/media/normal-face.e8d32268.svg";